<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Row -->
                    <div class="row">

                        <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5 hidden-xl hidden-lg">
                            <div class="tabs tabs-default margin-top-0 margin-bottom-25">
                                <div class="tabs-header">
                                    <ul style="width: 100%;">
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'visualizar'}" v-if="tab != 'editar'">
                                            <a v-on:click="setTab('visualizar')">
                                                <i class="material-icons">format_list_bulleted</i>
                                                Todas
                                            </a>
                                        </li>
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'cadastrar'}" v-if="tab != 'editar'">
                                            <a v-on:click="setTab('cadastrar')">
                                                <i class="material-icons">add_circle_outline</i>
                                                Criar nova
                                            </a>
                                        </li>   
                                        <li style="width: 50%;" v-on:click="editar(null);" v-if="tab == 'editar'">
                                            <a>
                                                <i class="material-icons">close</i>
                                                Cancelar edição
                                            </a>
                                        </li>
                                        <li style="width: 50%;" v-bind:class="{'active': tab == 'editar'}" v-if="tab == 'editar'">
                                            <a>
                                                <i class="material-icons">edit</i>
                                                Editar campanha
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12">
                            <!-- Dashboard Headline -->
                            <div class="dashboard-headline hidden-xs margin-bottom-25">
                                <h3>
                                    {{$router.currentRoute.meta.title}}
                                </h3>
                            </div>
                        </div>

                        <div class="col-xl-12">
                            <div class="row hidden-md hidden-xs">

                                <div class="col-lg-8 col-md-7 col-xs-12 col-xl-5">
                                    <a class="button margin-bottom-20 margin-right-5" v-on:click="setTab('visualizar')" v-bind:class="{'color-primary': tab == 'visualizar'}" v-if="tab != 'editar'">
                                        <i class="material-icons">format_list_bulleted</i>
                                        Todas
                                    </a>
                                    <a class="button outline margin-bottom-20" v-on:click="setTab('cadastrar')" v-bind:class="{'color-primary': tab == 'cadastrar'}" v-if="tab != 'editar'">
                                        <i class="material-icons">add_circle_outline</i>
                                        Criar nova                                
                                    </a>  
                                    <a class="button outline margin-bottom-20" v-on:click="editar(null);" v-if="tab == 'editar'">
                                        <i class="material-icons">close</i>
                                        Cancelar edição                              
                                    </a>                   
                                </div> 
                            </div> 
                        </div> 

                        <div class="col-xl-12" v-if="tab == 'visualizar'">
                            <div class="row">
                                <div class="col-lg-6 col-xs-12 col-xl-6">
                                    <p class="page-text margin-bottom-15">
                                        Confira abaixo as últimas campanhas criadas. Toque na campanha desejada para visualizar mais detalhes.
                                    </p>
                                </div>
                                <div class="col-xl-12">
                                    <h5 class="block-title">
                                        <i class="material-icons">list</i>
                                        Lista de campanhas
                                    </h5>                                    
                                    <h5 v-if="data.itens.length == 0 && data.loaded" class="empty">
                                        <i class="material-icons">close</i>                                            
                                        Nenhum resultado encontrado.
                                    </h5>                                    
                                    <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0 && data.loaded">
                                        <table class="table table-bordered table-bordered-default table-responsive" >
                                            <thead>
                                                <th style="min-width: 1px; width: 1px;">
                                                    ID
                                                </th>
                                                <th style="min-width: 200px;">
                                                    Nome
                                                </th>                                        
                                                <th style="min-width: 150px; width: 150px;">
                                                    Canais
                                                </th>  
                                                <th style="min-width: 135px; width: 135px;">
                                                    Criada em
                                                </th>     
                                                <th class="hidden-lg hidden-xl" style="min-width: 150px; width: 150px;">
                                                    Criada por
                                                </th>   
                                                   
                                                <th style="min-width: 135px; width: 135px;">
                                                    Data/hora de agendamento
                                                </th>                                                                                                     
                                                <th style="min-width: 110px; width: 110px;">
                                                    Ações
                                                </th>                                                                     
                                            </thead>
                                            <tbody>   
                                                <tr v-for="(item, index) in data.itens">
                                                    <td data-label="">
                                                        <a >
                                                            <span class="hidden-xl hidden-lg">ID: </span><b>#{{item.id}}</b>
                                                        </a>
                                                    </td>
                                                    <td data-label="Nome">
                                                        {{item.nome}}<br>
                                                        <small style="display: block; line-height: 130%; color: #555; margin-top: 5px; border-top: 1px solid rgba(0,0,0,0.05); padding-top: 5px; word-break: break-word;">
                                                            <i class="material-icons">search</i>
                                                            <b>Enviar para:</b> {{item.filtro.descricao}}
                                                        </small>
                                                        <small style="display: block; line-height: 130%; color: #555; margin-top: 5px; border-top: 1px solid rgba(0,0,0,0.05); padding-top: 5px; word-break: break-word;">
                                                            <i class="material-icons">people</i>
                                                            <b>Quantidade de pacientes:</b> {{item.relatorioTotal}}
                                                        </small>                                                        
                                                    </td>                 
                                                    <td data-label="Canais">
                                                        <span class="dashboard-status-button color-gray margin-bottom-3" v-if="item.smsEnviar == 1">SMS</span>
                                                        <span class="dashboard-status-button color-gray margin-bottom-3" v-if="item.emailEnviar == 1">E-mail</span>
                                                        <span class="dashboard-status-button color-gray margin-bottom-3" v-if="item.whatsappEnviar == 1">WhatsApp</span>
                                                        <span class="dashboard-status-button color-gray margin-bottom-3" v-if="item.pushEnviar == 1">Notificação push</span>
                                                    </td>
                                                    <td data-label="Criada em">
                                                        {{item.datahora | formatDateTime}}
                                                        <div style="height: 5px; width: 100%; display: block;"></div>
                                                        <span class="dashboard-status-button color-blue" v-if="item.status == 0 && item.agendamento == 0">Na fila de envio</span>
                                                        <span class="dashboard-status-button color-blue" v-if="item.status == 0 && item.agendamento == 1">Agendada</span>
                                                        <span class="dashboard-status-button color-orange" v-if="item.status == 1">Enviando</span>
                                                        <span class="dashboard-status-button color-green" v-if="item.status == 2">Enviada</span>
                                                        <span class="dashboard-status-button color-red" v-if="item.status == -1">Cancelada</span>
                                                    </td>  
                                                    <td data-label="Criada por" class="hidden-xl hidden-lg">
                                                        {{item.usuario.nome}}
                                                    </td>  
                                                    <td data-label="Data/hora de agendamento">
                                                        <b v-if="item.agendamento == 0">-</b>
                                                        <b v-if="item.agendamento == 1">{{item.data | formatDate}} {{item.hora.substr(0, 5)}}</b>
                                                    </td>                                                                                                        
                                                    <td data-label="Ações">

                                                        <div class="buttons" >   
                                                            <button type="button" class="dashboard-status-button gray margin-bottom-5" v-on:click="editar(item)">
                                                                <i class="material-icons">edit</i> Editar
                                                            </button>
                                                            <br class="hidden-xs hidden-md">
                                                            <button type="button" class="dashboard-status-button gray margin-bottom-5" v-on:click="del(item.cod)">
                                                                <i class="material-icons">close</i> Apagar
                                                            </button>                                                    
                                                            <br class="hidden-xs hidden-md">
                                                            <button type="button" class="dashboard-status-button gray margin-bottom-5" v-on:click="openDetalhes(item.cod)">
                                                                <i class="material-icons">playlist_add_check</i> Detalhes
                                                            </button>
                                                        </div> 

                                                    </td>                                                                                                                                       
                                                </tr>
                                            </tbody>
                                        </table>                            
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xl-12" v-if="tab == 'cadastrar' || tab == 'editar'">
                            <form type="post" v-on:submit.prevent="submit">
                                <div class="row">
                                    <div class="col-xl-12" v-if="tab == 'editar'">
                                        <h5 class="block-title margin-top-0 margin-bottom-20">
                                            <i class="material-icons">edit</i>
                                            Editar campanha
                                        </h5>     
                                    </div>
                                    <div class="col-xl-12" v-if="tab == 'cadastrar'">
                                        <h5 class="block-title margin-top-0">
                                            <i class="material-icons">add_circle_outline</i>
                                            Cadastrar nova campanha
                                        </h5>
                                    </div>                                    
                                    <div class="col-lg-6 col-xs-12 col-xl-6" v-if="tab == 'cadastrar'">
                                        <p class="page-text margin-bottom-25 margin-top-0">
                                            Realize um disparo em massa para os pacientes abaixo.
                                        </p>
                                    </div>
                                    <div class="col-xl-12 clearfix"></div>
                                    <div class="col-xl-6 col-md-6 col-lg-10">
                                        <div class="submit-field">
                                            <h5>Nome da campanha</h5>
                                            <input type="text" placeholder="..." v-model="form.nome" class="with-border">
                                        </div>
                                    </div>   

                                    <div class="col-xl-12 clearfix"></div>
                                    
                                    <div class="col-xl-7 col-md-6 col-lg-10">
                                        <div class="submit-field margin-bottom-10">
                                            <h5>Para quais pacientes deseja enviar?</h5>
                                            <select class="with-border margin-bottom-0" v-model="form.filtroCod">
                                                <option value="" disabled selected hidden>Selecione..</option>
                                                <option value="*">Todos</option>
                                                <option v-for="(item, index) in filtros.itens" :value="item.cod">{{item.objeto.descricao}}</option>
                                            </select>
                                            <small v-if="filtro.QNTD != null">
                                                <b>-</b> 
                                                Quantidade de pacientes: <b>{{filtro.QNTD}}</b>
                                            </small>
                                        </div>
                                    </div>   
                                    <div class="col-xl-8" v-if="filtro.QNTD != null && filtro.QNTD == 0">
                                        <p class="page-text margin-bottom-20 margin-top-0" style="border-color: red !important;">
                                            Nenhum paciente foi encontrado. Por favor, escolha acima outro filtro de pacientes.
                                        </p>                                        
                                    </div>                                        
                                    <div class="col-xl-12" v-bind:class="{'disabled': filtro.QNTD == null || filtro.QNTD == 0}">
                                        <div class="row">
                                            <div class="col-xl-12 clearfix"></div>
                                            <div class="col-xl-12 col-md-6 col-lg-12 margin-top-10">
                                                <hr class="hidden-lg hidden-xl">
                                                <div class="hidden-xl hidden-lg margin-top-20"></div>
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>Deseja enviar agora ou agendar?</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="enviar-agora" v-model="form.agendamento" true-value="0" false-value="1">
                                                        <label for="enviar-agora"><span class="checkbox-icon"></span> Enviar agora</label>
                                                    </div>
                                                </div>
                                            </div>                                
                                            <div class="col-xl-3 col-xs-8 col-md-7" v-if="form.agendamento == 1">
                                                <div class="submit-field margin-bottom-30">
                                                    <h5>Data</h5>
                                                    <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.data" required="">
                                                </div>
                                            </div>

                                            <div class="col-xl-2 col-xs-4 col-md-5" v-if="form.agendamento == 1">
                                                <div class="submit-field margin-bottom-30">
                                                    <h5>Hora</h5>
                                                    <input type="time" class="with-border" data-placeholder="__ : __" v-model="form.hora" required="">
                                                </div>
                                            </div>
                                            <div class="col-xl-12 clearfix"></div>
                                            <div class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="hidden-xl hidden-lg margin-top-25"></div>
                                                <div class="submit-field">
                                                    <h5>Onde será enviado</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-sms" true-value="1" false-value="0" v-model="form.smsEnviar">
                                                        <label for="lembrete-agendamento-sms"><span class="checkbox-icon"></span> SMS</label>
                                                    </div>
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-email" true-value="1" false-value="0" v-model="form.emailEnviar">
                                                        <label for="lembrete-agendamento-email"><span class="checkbox-icon"></span> E-mail</label>
                                                    </div>
                                                    <!-- <br> -->
        <!--                                             <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-whatsapp" true-value="1" false-value="0" v-model="form.whatsappEnviar">
                                                        <label for="lembrete-agendamento-whatsapp"><span class="checkbox-icon"></span> WhatsApp</label>
                                                    </div> -->
                                                    <br>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="lembrete-agendamento-push" true-value="1" false-value="0" v-model="form.pushEnviar">
                                                        <label for="lembrete-agendamento-push"><span class="checkbox-icon"></span> Notificação push</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xl-12 clearfix"></div>

                                            <div v-show="form.smsEnviar == 1" class="col-xl-12">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    SMS
                                                </h3>
                                            </div>
                                            <div v-show="form.smsEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field margin-top-25">
                                                    <h5>Texto que será enviado via SMS</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form.smsTexto" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>
                                            <div v-show="form.emailEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    E-mail
                                                </h3>                                        
                                            </div>
                                            <div v-show="form.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Assunto do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form.emailAssunto">
                                                </div>
                                            </div>

                                            <div v-show="form.emailEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título do e-mail</h5>
                                                    <input type="text" placeholder="..." class="with-border" v-model="form.emailTitulo">
                                                </div>
                                            </div>                                            

                                            <div v-show="form.emailEnviar == 1" class="col-xl-12 col-md-6 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto do e-mail</h5>
                                                    <trumbowyg v-model="form.emailTexto" :config="config" style="height: 400px;" class="" name="emailTexto"></trumbowyg>

                                                    <!-- <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form.emailTexto"></textarea> -->
                                                </div>
                                            </div>
                                            <div v-show="form.whatsappEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    WhatsApp
                                                </h3>                                        
                                            </div>
                                            <div v-show="form.whatsappEnviar == 1" class="col-xl-12 col-md-12 col-xs-12">
                                                <div class="submit-field">
                                                    <h5>Texto da mensagem a ser enviada via WhatsApp</h5>
                                                    <textarea placeholder="..." class="with-border" style="min-height: 100px;" v-model="form.whatsappTexto"></textarea>
                                                </div>
                                            </div>                                            
                                            <div v-show="form.pushEnviar == 1" class="col-xl-12 margin-bottom-25">
                                                <hr>
                                                <h3>
                                                    <i class="material-icons">info_outline</i>
                                                    Notificação Push
                                                </h3>                                               
                                            </div>
                                            <div v-show="form.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Título da notificação</h5>
                                                    <input type="text" placeholder="..." v-model="form.pushTitulo" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form.pushEnviar == 1" class="col-xl-6 col-md-6 col-lg-10">
                                                <div class="submit-field">
                                                    <h5>Link (opcional)</h5>
                                                    <input type="text" placeholder="..." v-model="form.pushLink" class="with-border">
                                                </div>
                                            </div>
                                            <div v-show="form.pushEnviar == 1" class="col-xl-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Texto da notificação</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form.pushTexto" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>        


                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-20" v-show="form.pushEnviar == 1 || form.emailEnviar == 1 || form.smsEnviar == 1 || form.whatsappEnviar == 1">
                                                <hr>
                                                <button type="submit" class="button big green block-mobile margin-top-25">
                                                    <i class="material-icons">save</i>
                                                    Salvar campanha
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>                                    
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div id="modal-campanha" class="modal">
            <div class="row" v-if="detalhes">
                <div class="col-lg-12">
                    <h3>Informações da campanha</h3>
                </div>
                <div class="col-lg-12 margin-bottom-20">
                    <h5>#{{detalhes.id}} - {{detalhes.nome}}</h5>
                </div>
                <div class="col-xs-6 col-xl-3 col-lg-4">
                    <div class="button-menu shadow">
                        <h1 class="margin-bottom-10">{{detalhes.relatorioTotal}}</h1>
                        Total de pacientes
                    </div>     
                </div>                
                <div class="col-xs-6 col-xl-3 col-lg-4">
                    <div class="button-menu shadow">
                        <h1 class="margin-bottom-10">{{detalhes.metricas.smsTotal}}</h1>
                        Total SMS
                    </div>
                </div>                
                <div class="col-xs-6 col-xl-3 col-lg-4">
                    <div class="button-menu shadow">
                        <h1 class="margin-bottom-10">{{detalhes.metricas.whatsappTotal}}</h1>
                        Total WhatsApp
                    </div>
                </div>                
                <div class="col-xs-6 col-xl-3 col-lg-4">
                    <div class="button-menu shadow">
                        <h1 class="margin-bottom-10">{{detalhes.metricas.emailTotal}}</h1>
                        Total e-mail
                    </div>
                </div>                
                <div class="col-xs-6 col-xl-3 col-lg-4">
                    <div class="button-menu shadow">
                        <h1 class="margin-bottom-10">{{detalhes.metricas.pushTotal}}</h1>
                        Total notificação push
                    </div>                              
                </div>                
            </div>
        </div>

        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Campanhas',
    components: {
        'Trumbowyg':                VueTrumbowyg.default,
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            // var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            // d = time.split(":");
            // time = d[0] + ":" + d[1];
            return date;

        },
        formatDateTime: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            return date + " " + time;
        }, 
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
            } else {
                return "0,00";
            }
        },        
    },    
    data () {
        var self                    = this;
        return {
            config: {
                svgPath:            "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['fontsize'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                    // ['fullscreen']
                ]
            },               
            "loaded":               false,
            "tab":                  "visualizar",
            "data":                 {
                "itens":            []
            },
            "filtro":                 {
                "QNTD":             null
            },              
            "filtros":              {
                "itens":            []
            }, 
            "detalhes":              null,                 
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "nome":             "",
                "agendamento":  0,
                "tipo":         "campanha",
                "filtroCod":    "",
                "relatorioTotal": 0,
                "hora":         "",
                "destinatarios": ["*"],
                "data":         "",
                "pushEnviar":   0,
                "pushTitulo":   "",
                "pushTexto":    "",
                "pushLink":     "",
                "smsEnviar":    0,
                "smsTexto":     "",
                "emailEnviar":  0,
                "emailTitulo":  "",
                "emailAssunto": "",
                "whatsappEnviar":0,
                "whatsappTexto":"",
            },
        }
    },
    watch: {
        "form.filtroCod": function(val) {
            var self = this;
            console.log("watch form.filtroCod>", val);
            if (val) {
                self.getQuantidadeFiltro(val);
            }
        }      
    },
    methods: {       
        setTab: function(tab) {
            var self        = this;
            console.log("setTab()", tab);
            self.tab        = tab;
            $(".dashboard-content-inner")[0].scrollTo({
                top: 1
            });              
        },   
        openDetalhes: function(cod) {
            var self = this;
            console.log("openDetalhes()", cod);       
            self.detalhes           = null;

            loading.show();

            window.__modalCampanha   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   ['overlay', '', 'escape'],
                closeLabel:     "",
                cssClass:       ["modal-campanha"]
            });   

            var form = {
                "params": {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "tipo":         "informacoes",
                    "cod":          cod
                }
            };

            axios.get("api/notificacoes.php", form)
            .then(response => {
                
                console.log("openDetalhes() response", response);
                self.detalhes       = response.data.result;
                self.$forceUpdate();

                setTimeout(function() {
                    window.__modalCampanha.setContent(document.querySelector('#modal-campanha').innerHTML);      
                    window.__modalCampanha.open();
                    loading.hide();
                    setTimeout(function() {
                        $(".modal-campanha").append('<a class="close" onclick="window.__modalCampanha.close();"><i class="material-icons">close</i></a>');    
                    }, 100);
                }, 500);

            })
            .catch(error => {
                console.log("openDetalhes() error", error);                    
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
               
            }); 

        },
        editar: function(item) {
            var self = this;

            if (!item) {
                self.form = {
                    "_cod":             self.$root.user.cod,
                    "_token":           self.$root.user.token,
                    "nome":             "",
                    "agendamento":  0,
                    "tipo":         "campanha",
                    "hora":         "",
                    "destinatarios": ["*"],
                    "data":         "",
                    "pushEnviar":   0,
                    "pushTitulo":   "",
                    "pushTexto":    "",
                    "pushLink":     "",
                    "smsEnviar":    0,
                    "smsTexto":     "",
                    "emailEnviar":  0,
                    "emailTitulo":  "",
                    "emailAssunto": "",
                    "whatsappEnviar":0,
                    "whatsappTexto":"",
                }      
                self.filtro             = {"QNTD": null};
                self.setTab("visualizar");
                return false;          
            }

            var form = {
                "params": {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          item.cod
                }
            };

            axios.get("api/notificacoes.php", form)
            .then(response => {
                
                console.log("get() response", response);
                self.form           = response.data.result;
                self.setTab("editar");

            })
            .catch(error => {
                console.log("get() error", error);                    
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
               
            });              
        },        
        getQuantidadeFiltro: function(cod) {
            var self        = this;
            loading.show();
            console.log("getQuantidadeFiltro()", cod);
            return new Promise(function(resolve, reject) {
                self.filtro             = {"QNTD": null};
                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "filtroCod":    cod,
                        "tipo":         "quantidade"
                    }
                };

                axios.get("api/notificacoes.php", form)
                .then(response => {
                    
                    console.log("getQuantidadeFiltro() response", response);
                    self.filtro         = response.data.result;
                    self.form.relatorioTotal = response.data.result.QNTD;
                    loading.hide();
                    self.$forceUpdate();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getQuantidadeFiltro() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        get: function() {
            var self        = this;
            console.log("get()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/notificacoes.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.data           = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                loading.show();
                
                axios.delete("api/notificacoes.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.get().then(function() {
                        loading.hide();
                    }).catch(function() {
                        loading.hide();
                    });                 
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
        submit: function() {
            var self            = this;
            var form            = JSON.parse(JSON.stringify(self.form));
            form._cod           = self.$root.user.cod;
            form._token         = self.$root.user.token;

            console.log("submit()", form);            
            var a               = "post";
            if (self.form.cod) {
                a               = "put";
            }

            loading.show();
            axios[a]("api/notificacoes.php", form)
            .then(response => {
                
                console.log("submit() response", response)
                loading.hide();

                $(".dashboard-content-inner")[0].scrollTo({
                    top: 5
                });  
                self.get();
                
                self.editar(null);


                alert(response.data.message);
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },  
        getFiltros: function() {
            var self        = this;
            console.log("getFiltros()");
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "multiplo":     true,
                        "nome":         "filtro-campanha"
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("getFiltros() response", response);
                    self.filtros.itens      = response.data.result.itens;
                    console.log("FILTROS:", self.filtros)
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getFiltros() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                   
                });   
            });   
        }                
    },
    created: function() {
        var self = this;

        loading.show();

        Promise.all([
            self.get(),
            self.getFiltros()
        ]).then(function() {
        
            self.$forceUpdate();
            loading.hide();
            
        }).catch(function(error) {
            loading.hide();
        });         

    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    td a.dashboard-status-button {
        padding-top: 8px;
        margin-right: 5px;
        color: #333;
        font-weight: 300;
        line-height: 20px;
        top: 0px;
        margin-top: 0px;
        border: 1px solid #ddd;
    }
    td a.dashboard-status-button i {
        /*color: #fff;*/
        display: inline-block !important;
        top: 1px;
        margin-top: 0px;
    }    
  
    .tabs-default .tabs-header a {
        font-size: 14px;
    }    
</style>



// WEBPACK FOOTER //
// src/components/Campanhas.vue